// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__19xOa","title":"Header_title__1VaHj","side":"Header_side__3TrEa"};